import { PERMISSIONS as P } from "@lib/permissions/permissions.generated";

export const TARIF_PERMISSIONS = {
  GRILLES_VIEW: P.VENTES.TARIFS.VIEW,
  GRILLES_CREATE: P.VENTES.TARIFS.CREATE,
  GRILLES_EDIT: P.VENTES.TARIFS.EDIT,
  GRILLES_DELETE: P.VENTES.TARIFS.DELETE,
  PROMOTIONS_VIEW: P.VENTES.PROMOTIONS.VIEW,
  PROMOTIONS_CREATE: P.VENTES.PROMOTIONS.CREATE,
  PROMOTIONS_EDIT: P.VENTES.PROMOTIONS.EDIT,
  PROMOTIONS_DELETE: P.VENTES.PROMOTIONS.DELETE,
  PROFILS_VIEW: "ventes.profils.view",
  PROFILS_CREATE: "ventes.profils.create",
  PROFILS_EDIT: "ventes.profils.edit",
  PROFILS_DELETE: "ventes.profils.delete",
  TAXES_VIEW: "ventes.taxes.view",
  TAXES_CREATE: "ventes.taxes.create",
  TAXES_EDIT: "ventes.taxes.edit",
  TAXES_DELETE: "ventes.taxes.delete",
  ORGANISMES_VIEW: "ventes.organismes.view",
  ORGANISMES_CREATE: "ventes.organismes.create",
  ORGANISMES_EDIT: "ventes.organismes.edit",
  ORGANISMES_DELETE: "ventes.organismes.delete",
} as const;

export const CODE_REGEX = /^[A-Z][A-Z0-9_]*$/;
export const CODE_MESSAGE =
  "Doit commencer par une lettre majuscule, suivie de majuscules, chiffres ou underscores";
export const REMISE_MIN = 0;
export const REMISE_MAX = 100;
export const STATUT_OPTIONS = ["Actif", "Inactif"] as const;
export const PROMO_TYPE_OPTIONS = ["pourcentage"] as const;
export const ECHELON_TYPE_OPTIONS = ["remise", "rabais"] as const;
